﻿import { CommonFlags as c, EntityColumn, EntityColumnFlags, EntityLookup, MicroMClient, ValuesObject } from '@mcurros2/microm';
import { catTiposDomicilio } from 'Entities/Categorias y Estados/catTiposDomicilio';
import { Ciudades } from '../../Entities/Paises/Ciudades/Ciudades';
import { Localidades } from '../../Entities/Paises/Localidades/Localidades';
import { Paises } from '../../Entities/Paises/Paises';
import { Provincias } from '../../Entities/Paises/Provincias/Provincias';

// MMC: extract interface for DomiciliosColumns
export interface IDomiciliosColumns {
    f_latitud: EntityColumn<number>;
    f_longitud: EntityColumn<number>;
    i_utc_offset_minutes: EntityColumn<number>;
    c_pais_id: EntityColumn<string>;
    c_provincia_id: EntityColumn<string>;
    c_ciudad_id: EntityColumn<string>;
    c_localidad_id: EntityColumn<string>;
    vc_calle: EntityColumn<string>;
    vc_altura: EntityColumn<string>;
    vc_piso: EntityColumn<string>;
    vc_departamento: EntityColumn<string>;
    vc_codigopostal: EntityColumn<string>;
    vc_domicilio_completo: EntityColumn<string>;
    vc_tiposdomicilio: EntityColumn<string>;
}

export const DomiciliosColumnKeys: string[] = [
    'f_latitud', 'f_longitud', 'i_utc_offset_minutes',
    'c_pais_id', 'c_provincia_id', 'c_ciudad_id', 'c_localidad_id',
    'vc_calle', 'vc_altura', 'vc_piso', 'vc_departamento',
    'vc_codigopostal', 'vc_domicilio_completo', 'vc_tiposdomicilio'
];


export const DomiciliosColumns = (required?: boolean): IDomiciliosColumns =>
(
    {
        f_latitud: new EntityColumn<number>({
            name: 'f_latitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Latitud',
            description: 'Indica la latitud de la posición GPS'
        }),
        f_longitud: new EntityColumn<number>({
            name: 'f_longitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Longitud',
            description: 'Indica la longitud de la posición GPS'
        }),
        i_utc_offset_minutes: new EntityColumn<number>({
            name: 'i_utc_offset_minutes', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Utc Offset Minutes',
            description: 'Indica la diferencia en minutos con respecto a la hora UTC'
        }),
        c_pais_id: new EntityColumn<string>({
            name: 'c_pais_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'País',
            description: 'Indique el país'
        }),
        c_provincia_id: new EntityColumn<string>({
            name: 'c_provincia_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Provincia',
            description: 'Indique la provincia'
        }),
        c_ciudad_id: new EntityColumn<string>({
            name: 'c_ciudad_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Ciudad',
            description: 'Indique la ciudad'
        }),
        c_localidad_id: new EntityColumn<string>({
            name: 'c_localidad_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Localidad',
            description: 'Indique la localidad'
        }),
        vc_calle: new EntityColumn<string>({
            name: 'vc_calle', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Calle',
            description: 'Indique la calle'
        }),
        vc_altura: new EntityColumn<string>({
            name: 'vc_altura', type: 'varchar', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Numeración calle',
            description: 'Indique la numeración de la calle'
        }),
        vc_piso: new EntityColumn<string>({
            name: 'vc_piso', type: 'varchar', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Piso',
            description: 'Indique el piso'
        }),
        vc_departamento: new EntityColumn<string>({
            name: 'vc_departamento', type: 'varchar', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Apartamento',
            description: 'Indique el apartamento'
        }),
        vc_codigopostal: new EntityColumn<string>({
            name: 'vc_codigopostal', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Código postal',
            description: 'Indique el código postal'
        }),
        vc_domicilio_completo: new EntityColumn<string>({
            name: 'vc_domicilio_completo', type: 'varchar', length: 2048, flags: required ? c.Edit : (c.Edit | EntityColumnFlags.nullable), prompt: 'Domicilio',
            description: 'Ingrese el domiclio a buscar'
        }),
        vc_tiposdomicilio: new EntityColumn<string>({
            name: 'vc_tiposdomicilio', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo de Domicilio', isArray: true,
            description: 'Indique los tipos de domicilio'
        }),

    }
)


export interface IDomiciliosLookups extends Record<string, EntityLookup> {
    Paises: EntityLookup;
    Provincias: EntityLookup;
    Ciudades: EntityLookup;
    Localidades: EntityLookup;
    TiposDomicilio: EntityLookup;
}

export const DomiciliosLookupsKeys: string[] = ['Paises', 'Provincias', 'Ciudades', 'Localidades', 'TiposDomicilio'];

export const DomiciliosLookups = (): IDomiciliosLookups =>
(
    {
        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Provincias(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Ciudades(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Localidades(client, parentKeys)
        },
        'TiposDomicilio': {
            name: 'TiposDomicilio',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposDomicilio(client, parentKeys)
        }
    }
)
